module.exports = __webpack_public_path__ + "img/credits.0c45f1ad.png";